export const banksHeaders = [
  { title: 'ID', key: 'id' },
  { title: 'Account Name', key: 'accountName', sortable: false },
  { title: 'Bank Name', key: 'bankName', sortable: false },
  { title: 'Account No.', key: 'bankNumber', align: 'start', sortable: false },
  { title: 'IFSC Code', key: 'bankIfscCode', align: 'start', sortable: false },
  { title: 'Branch Address', key: 'bankBranchAddress', align: 'start', sortable: false },
  { title: 'Account Type', key: 'bankType', align: 'start', sortable: false },
  { title: 'PAN No.', key: 'bankPanNumber', align: 'start', sortable: false },
  { title: 'Primary', key: 'isDefault', align: 'center', sortable: false },
  { title: 'Created Timestamp', key: 'createdAt', align: 'start' },
  { title: 'Updated Timestamp', key: 'updatedAt', align: 'start' },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
]

export const bankSearchFields: any = reactive({
  accountName: '',
  bankName: '',
  bankIfscCode: '',
  bankBranchAddress: '',
  bankType: '',
  bankPanNumber: '',
})

export const resetBankFields = { ...bankSearchFields }
